import * as React from 'react';

import {renderOptionForToolbar} from 'shells/timeline/entry/toolbar/helpers';
import type {ToolbarOption} from 'shells/timeline/entry/toolbar/timeline-entry-toolbar';

import {TimelineEntryContent} from '../entry/timeline-entry-content';
import type {Props as TimelineEntryContentProps} from '../entry/timeline-entry-content';

import styles from './timeline-entry-modal-content.module.css';

type Props = // Content Props
    TimelineEntryContentProps & {
        htmlContent?: string;
        changeLogEntryId: string;
        actionMenu?: React.ReactNode;
        additionalToolbarOptions?: ToolbarOption[];
    };

export function TimelineEntryModalContent(props: Props) {
    const {
        changeLogEntryId,
        subject,
        subjectTitle,
        content,
        status,
        participants,
        relatedLeads,
        actionMenu,
        metadata,
        htmlContent,
        additionalToolbarOptions,
        maxHeight,
    } = props;

    return (
        <TimelineEntryContent
            changeLogEntryId={changeLogEntryId}
            subject={subject}
            subjectTitle={subjectTitle}
            content={content}
            htmlContent={htmlContent}
            status={status}
            metadata={metadata}
            participants={participants}
            relatedLeads={relatedLeads}
            maxHeight={maxHeight}
            actions={
                <div className={styles['action-menu-container']}>
                    {additionalToolbarOptions
                        ? additionalToolbarOptions.map((option) => renderOptionForToolbar(option))
                        : undefined}
                    {actionMenu}
                </div>
            }
        />
    );
}
